import { fromPromise } from 'xstate';

import { tokenProvider } from '../../../../../../../../session-token-provider';

/**
 * Auth-token source for the live-transcription WebSocket handshake.
 *
 * Routes through the shared `tokenProvider` (which drives the session machine
 * to `TokenAvailable`) rather than reading SuperTokens directly, so the socket
 * authenticates with the same managed, refresh-aware token the Apollo HTTP
 * path uses: an expired token is refreshed before it is returned, and
 * concurrent acquisitions are de-duplicated/coalesced. Previously this called
 * `Session.getAccessToken()` directly, which could hand a stale or already
 * expired token to the handshake (the socket is auth'd once at connect and
 * never re-validated) — the token half of the snapshot problem fixed for
 * tenantId in [ENG-4407].
 */
export const getAuthToken = fromPromise<{ token: string | undefined }>(
  async () => {
    const { jwt } = await tokenProvider();
    return { token: jwt };
  },
);
